// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilePicker_wrapper__3RKSw","placeholder":"FilePicker_placeholder__3Pwkt","icon":"FilePicker_icon__3MEjk"};